import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateGroupFooter = (props) => {
  const { mykey, id, jenis_mobil, merek, nomor_polisi, tahun } =
    props.group_data;
  const group_count = props.group_count ?? 0;

  return (
    <tr
      key={`${mykey}-group-footer-${props.group_label}`}
      className={`row-start-start ${tableWidth} text-sm text-slate-700`}
    >
      <td
        className={`row-start-start w-full border-zinc-300 border border-t-0  px-2 pt-3 pb-3 gap-3 font-semibold pl-14 ${
          group_count > 0 ? "text-red-600" : ""
        }`}
      >
        <span className="underline"> Total {nomor_polisi} : </span>
        <span>{group_count.toLocaleString("id-ID")} </span>
        <span> warning </span>
      </td>
    </tr>
  );
};

export default ReportTemplateGroupFooter;
